// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"78235c61","570":"06091b21","578":"0679ac2d","579":"ab36a751","914":"6e2bdcce","986":"a9f42cef"}[chunkId] + ".chunk.js";
};